import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { UsersService } from "src/app/api/users.service";
import { LoaderService } from "src/app/core/Loader.services";
import {
  AppRoutePaths,
  AppRoutes,
} from "src/app/shared/common/app-path.routes";

@Component({
  standalone: true,
  selector: "app-call-back-component",
  imports: [],
  templateUrl: "./call-back-component.component.html",
  styleUrl: "./call-back-component.component.css",
})
export class CallBackComponentComponent implements OnInit {
  private oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  private router = inject(Router);
  private userService = inject(UsersService);
  private loader: LoaderService = inject(LoaderService);

  async ngOnInit(): Promise<void> {
    try {
      //this.loader.show();
      const isAuthenticated = await this.oktaAuth.isAuthenticated();
      if (isAuthenticated) {
        await this.userService.startLogin();
        // this.router.navigateByUrl(AppRoutePaths[AppRoutes.Dashboard]);
      } else {
        // Handle the login redirect and obtain tokens
        await this.oktaAuth.handleLoginRedirect();
      }
      //this.loader.hide();
    } catch (error) {
      console.error("Error during login redirect:", error);
      this.userService.LoginErrorMsg.set("You don't have access to CP Central, For new CP Central account, please click the 'Register' button and complete the form, we will process your registration in the order in which it was received.");
      // Handle the error appropriately
      this.router.navigateByUrl(AppRoutePaths[AppRoutes.Login]);
    }
  }
}
